import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { AppBar, Button, Drawer, IconButton, Menu, MenuItem, Toolbar, Typography, useMediaQuery } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import EditIcon from '@material-ui/icons/Edit';
import MenuIcon from '@material-ui/icons/Menu';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import { useSiteContext } from '../../SiteContext';
import { SiteComponent } from '../SiteComponentPlugin';
import NavThemeProvider from './NavThemeProvider';
import { SlotRenderer } from '../renderers';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import ComponentPicker from '../../common/pickers/ComponentPicker';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
const StyledSecurePortal = styled.div `
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  nav {
    display: flex;
    flex-direction: column;
    z-index: 1;
    &.nav-close {
      transition-property: margin-left;
      transition-duration: ${props => props.theme.transitions.duration.leavingScreen}ms;
      transition-timing-function: ${props => props.theme.transitions.easing.sharp};
      margin-left: -260px;
      /* margin-left: -242px; */
    }
    &.nav-open {
      transition-property: margin-left;
      transition-duration: ${props => props.theme.transitions.duration.enteringScreen}ms;
      transition-timing-function: ${props => props.theme.transitions.easing.easeOut};
      margin-left: 0;
    }
    ${props => props.theme.breakpoints.down('md')} {
      &.nav-close {
        margin-left: 0;
      }
    }
  }
  main {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
    z-index: 0;
  }
`;
const StyledDrawer = styled(Drawer) `
  width: 260px;
  .paper {
    width: 260px;
    background-color: #f1f3f3;
  }
`;
const StyledNavAppBar = styled(AppBar) ``;
const StyledToolbar = styled(Toolbar) `
  padding-left: 0px;
  padding-right: 0px;
  align-items: flex-start;
  flex-direction: column;

  .content {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo-container {
      width: 100%;
      padding-left: 24px;
      padding-right: 24px;

      .logo {
        display: block;
        margin: auto auto 5px auto;
      }
    }
  }
`;
const StyledMainAppBar = styled(AppBar) `
  /* background-color: #fff; */
  .flex {
    flex: 1;
  }
  .logo {
    height: 27px;
  }
`;
const useNavOpen = (isAboveMediumSize) => {
    // hide the navigation if member has not signed an agreement
    const [isNavOpen, setIsNavOpen] = useState(isAboveMediumSize);
    const previousIsAboveMediumSizeRef = useRef(isAboveMediumSize);
    // only force nav open/close when a breakpoint change occurs
    if (isAboveMediumSize !== previousIsAboveMediumSizeRef.current) {
        if (!isNavOpen && isAboveMediumSize) {
            setIsNavOpen(true);
        }
        else if (isNavOpen && !isAboveMediumSize) {
            setIsNavOpen(false);
        }
    }
    useEffect(() => {
        // Store the previous breakpoint change
        previousIsAboveMediumSizeRef.current = isAboveMediumSize;
    }, [isAboveMediumSize]);
    return [isNavOpen, setIsNavOpen];
};
export const SitePortal = props => {
    const component = useSubscribeComponentChanges(SitePortalPlugin, props);
    const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
    // const { user } = useUserContext();
    // const { doLogout } = useLogout();
    const isAdmin = true; //user?.roles?.some(r => r.name === 'Admin');
    const isAboveMediumSize = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true } // prevents 2 render calls on load
    );
    const showNav = true; //user?.isPasswordSet; // hide nav if setting up user
    const [isNavOpen, setIsNavOpen] = useNavOpen(isAboveMediumSize);
    const history = useHistory();
    const handleDrawerToggle = () => {
        setIsNavOpen(!isNavOpen);
    };
    const handleClickProfile = () => {
        setProfileMenuAnchor(null);
        history.push(`/portal/user-profile/`);
    };
    const handleClickLogout = () => {
        setProfileMenuAnchor(null);
        // doLogout();
    };
    const handleNavigationItemClick = () => {
        if (!isAboveMediumSize) {
            setIsNavOpen(false);
        }
    };
    // if (
    //   !user?.isPasswordSet &&
    //   !history.location.pathname.includes('/portal/setup')
    // ) {
    //   // The user's password is not set, so setup the user
    //   return <Redirect to='/portal/setup' />;
    // } else if (history.location.pathname.replace(/\//g, '') === 'portal') {
    //   if (isAdmin) {
    //     // if navigating to /portal, redirect to customers section for admins
    //     return <Redirect to='/portal/organizations' />;
    //   } else {
    //     // TODO: figure out roles access
    //     return <Redirect to='/portal/teams' />;
    //   }
    // }
    const { isHover, hoverProps } = useSiteContext();
    const classes = ['site-portal'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    return (React.createElement(SiteComponent, Object.assign({ plugin: SitePortalPlugin }, props),
        React.createElement(StyledSecurePortal, Object.assign({ className: classes.join(' ') }, hoverProps(component)),
            showNav && (React.createElement("nav", { className: isNavOpen ? 'nav-open' : 'nav-close' },
                React.createElement(NavThemeProvider, null,
                    React.createElement(StyledDrawer, { variant: isAboveMediumSize ? 'persistent' : 'temporary', anchor: 'left', open: isNavOpen, onClose: handleDrawerToggle, classes: {
                            paper: 'paper'
                        }, PaperProps: { elevation: 10 }, ModalProps: {
                            keepMounted: true // Better open performance on mobile.
                        } },
                        React.createElement(StyledNavAppBar, { position: 'static', elevation: 1, square: true },
                            React.createElement(StyledToolbar, null,
                                React.createElement("div", { className: 'content' },
                                    React.createElement(Typography, { variant: 'h6', noWrap: true, className: 'logo-container' },
                                        React.createElement("img", { src: '/assets/sl-logo.png', className: 'logo', alt: 'Sierra Labs' }))))),
                        React.createElement(SlotRenderer, { component: component, slot: 'navigation' }))))),
            React.createElement("main", null,
                React.createElement(StyledMainAppBar, { position: 'static', color: 'secondary' },
                    React.createElement(Toolbar, null,
                        showNav && (React.createElement(IconButton, { color: 'inherit', "aria-label": 'open drawer', edge: 'start', onClick: handleDrawerToggle },
                            React.createElement(MenuIcon, null))),
                        (!showNav || !isNavOpen) && (React.createElement("img", { src: '/assets/sl-logo.png', alt: 'Sierra Labs', className: 'logo' })),
                        React.createElement("span", { className: 'flex' }),
                        React.createElement(Button, { className: 'user-button', onClick: e => setProfileMenuAnchor(e.currentTarget) },
                            React.createElement(ArrowDropDownIcon, null)),
                        React.createElement(Menu, { id: 'profile-menu', anchorEl: profileMenuAnchor, keepMounted: true, open: Boolean(profileMenuAnchor), onClose: e => setProfileMenuAnchor(null) },
                            React.createElement(MenuItem, { onClick: handleClickProfile }, "Profile"),
                            React.createElement(MenuItem, { onClick: handleClickLogout }, "Logout")),
                        React.createElement(IconButton, { size: 'small', component: Link, to: `/admin?path=${history.location.pathname}` },
                            React.createElement(EditIcon, null)))),
                React.createElement(SlotRenderer, { component: component, slot: 'routes' })))));
};
export const SitePortalConfigurator = props => {
    var _a, _b;
    const { component, update, updateSlot } = useConfigComponent(props.component);
    const navigationComponent = (_a = component.children) === null || _a === void 0 ? void 0 : _a.find(c => c.slot === 'navigation');
    const contentComponent = (_b = component.children) === null || _b === void 0 ? void 0 : _b.find(c => c.slot === 'content');
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(ComponentPicker, { label: 'Navigation', value: (navigationComponent === null || navigationComponent === void 0 ? void 0 : navigationComponent.type) || '', onTypeChange: type => {
                    updateSlot('navigation', type);
                } }))));
};
export const SitePortalPlugin = {
    name: 'Site Portal',
    type: 'site-portal',
    component: SitePortal,
    configurator: SitePortalConfigurator,
    slots: [
        {
            name: 'Routes',
            type: 'component-stack',
            slot: 'routes'
        }
    ]
};
//# sourceMappingURL=SitePortalPlugin.js.map